module.exports = __webpack_public_path__ + "static/media/advert.aa99ce29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/advert.png
// module id = 1136
// module chunks = 0